import '~/js/modules/stickyNav';
import RoomAccommodations from '~/js/components/accommodations/MainPanel';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

const villageCode = 'BIT';

const isMobileDevice = () => {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

if (isMobileDevice()) {
  const element = document.querySelector('.drag-icon');

  element.classList.add('mobile-browser');
}

ReactDOM.render(
  <RoomAccommodations
    resortCode="btc"
    villageCode={ villageCode }
    accomodationTitle="the italian village"
  />,
  document.querySelector('#root')
);
